import React from 'react'
import image1 from "../../images/INSIGHTS-ANALYTICS.jpg"
import image2 from "../../images/Showcase-local-events.jpg"
import image3 from "../../images/Grow-your-community.jpg"

const Twocolumn = () => {
  return (
    <section className='twocolumn' id="feature">
        <div className='container'>
            <div className='twocolumn-row'>
              <div className='col-50'>
                <div className='image'>
                  <img src={image1} alt="INSIGHTS & ANALYTICS" />
                </div>
              </div>
              <div className='col-50'>
                  <div className='content'>
                    <label>INSIGHTS & ANALYTICS</label>
                    <h2>Connect with residents</h2>
                    <p>Find actionable information about which attractions in the council have a higher footfall.</p>
                  </div>
              </div>
            </div>
            <div className='twocolumn-row'>
              <div className='col-50'>
                <div className='image'>
                  <img src={image2} alt="INSIGHTS & ANALYTICS" />
                </div>
              </div>
              <div className='col-50'>
                  <div className='content'>
                    <label>DRIVE IN-STORE SALES & TRAFFIC</label>
                    <h2>Showcase local events</h2>
                    <p>Boost local events and festivals among the council residents.</p>
                  </div>
              </div>
            </div>
            <div className='twocolumn-row'>
              <div className='col-50'>
                <div className='image'>
                  <img src={image3} alt="INSIGHTS & ANALYTICS" />
                </div>
              </div>
              <div className='col-50'>
                  <div className='content'>
                    <label>INTERACT WITH THE COMMUNITY</label>
                    <h2>Grow your community</h2>
                    <p>Bring the people in the community together.</p>
                  </div>
              </div>
            </div>
        </div>
    </section>
  )
}

export default Twocolumn